var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvester(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2C1.89543 2 1 2.89543 1 4V13.0141H5.73779C9.53469 13.0141 12.6127 9.93611 12.6127 6.13921V2H3ZM5.73778 13.7484H1V22.7625C1 23.8671 1.89543 24.7625 3 24.7625H12.6127V20.6233C12.6127 16.8264 9.53468 13.7484 5.73778 13.7484ZM13.3873 2H23C24.1046 2 25 2.89543 25 4V13.0141H20.2622C16.4653 13.0141 13.3873 9.93612 13.3873 6.13921V2ZM20.2622 13.7484C16.4653 13.7484 13.3873 16.8264 13.3873 20.6233V24.7625H23C24.1046 24.7625 25 23.8671 25 22.7625V13.7484H20.2622Z",
    fill: "url(#paint0_linear_1617_4463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_4463",
    x1: 25,
    y1: 13.7738,
    x2: 14.0266,
    y2: 25.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvester);
export default __webpack_public_path__ + "static/media/invester.2192230faebf9e9a4688833b80296055.svg";
export { ForwardRef as ReactComponent };